/**
 * The three market-data formatters the panel and the history modal both
 * render (`AUT-231`, `AUT-303`). They live here rather than in either
 * component because the panel imports the modal: importing them back out of
 * the panel would close an import cycle.
 *
 * Every one falls back to an em dash rather than to `0` or a blank -- a
 * missing price and a price of zero are different facts, and
 * `landscape_products` supplies plenty of the former
 * (`components/product.md § The ruling on price, rating and review count —
 * do not reopen`).
 */

export function formatMoney(value: number | string | null): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(n)) return '—';
  return `$${n.toFixed(2)}`;
}

export function formatRating(value: number | string | null): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(n)) return '—';
  return n.toFixed(1);
}

export function formatReviews(value: number | null): string {
  if (value === null) return '—';
  return value.toLocaleString();
}
